<template>
  <div>
        <shelvesStore2 rawtitle='门店列表' v-if="productFlag" :sendData='sendData' :searchKey='{key:"name",placeholder:"请输入门店名"}' :isshow.sync='productFlag'  :excludeList='tableData' @onClick='saveret' :config="config" :keyItem='keyItem' :isselectOpen='false'>
            <el-table-column
            :prop="keyItem"
            label="门店id"
            align='center'
            width="70">
          </el-table-column>
          <el-table-column  width="270" :label="$t('message.操作')" align="center" v-if="sendData.filterConfig.type===0">
            <template slot-scope="scope">
              <el-button-group >
                <el-button size="mini"  type="normal"   @click="setStore(scope.row)">增加库存</el-button>
                <!-- <el-button size="mini"  type="normal"   @click="setProd(scope.row)">新增商品</el-button> -->
                <el-button size="mini"  type="normal"   @click="editProd(scope.row)">新增库存</el-button>
                <el-button size="mini"  type="normal"   @click="editStore(scope.row)">修改库存</el-button>

              </el-button-group>
            </template>
          </el-table-column>
          <el-table-column
            prop="shopMain.name"
            label="门店名"
            width="150"
            align='center'

            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            prop="shopMain.address"
            label="地址"
            min-width="280"
            align='center'

            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column  width="80" label="库存类型" align="center" >
            <template slot-scope="scope">
             {{scope.row.type?'外部库存':'内部库存'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="inventory"
            label="库存量"
            width="70"
            align='center'
            show-overflow-tooltip
            >
          </el-table-column>
           
        </shelvesStore2>
    
    <div style="height:20px"></div>
    <el-select v-model="sendData.filterConfig.type" placeholder="请选择">
    <el-option
      label="内部商品"
      :value="0">
    </el-option>
    <el-option
      label="外部商品"
      :value="1">
    </el-option>
    
  </el-select>
  <el-button size="medium" round  @click="selectProduct" :disabled="!isModify">
              选择门店
    </el-button>
     <modalreal :zIndexEdit='false' :width='600' :height='550' v-if="showConfig">
      <div slot="title">
        设置{{setobj.shopMain.name}}门店的商品{{prodID.name}}
      </div>
      <div style="flex:1" slot="contner">
        <div class="grid-content content-margin">
          <table class="simpleRow">
        <tr >
          <td>
            <span class="simpleLabel">商品库存</span>
          </td>
          <td>
              <el-input-number   v-model="configser.inventory" size="mini"  :disabled='!isadd' />
          </td>
        </tr>
         <tr >
          <td>
            <span class="simpleLabel">库存警报触发量</span>
          </td>
          <td>
              <el-input-number   v-model="configser.inventoryalarm" size="mini"   />
          </td>
        </tr>
        <tr >
          <td>
            <span class="simpleLabel">库存紧张触发量</span>
          </td>
          <td>
              <el-input-number   v-model="configser.inventorytense" size="mini"   />
          </td>
        </tr>
        <tr >
          <td>
            <span class="simpleLabel">自动下架触发量</span>
          </td>
          <td>
              <el-input-number   v-model="configser.inventoryoffshelf" size="mini"   />
          </td>
        </tr>
        <tr >
          <td>
            <span class="simpleLabel">兑换商品所需积分</span>
          </td>
          <td>
              <el-input-number   v-model="configser.price" size="mini"   />
          </td>
        </tr>
        <tr >
          <td>
            <span class="simpleLabel">进货价</span>
          </td>
          <td>
              <el-input-number   v-model="configser.replenishprice" size="mini"   />
          </td>
        </tr>
        <tr >
          <td>
            <span class="simpleLabel">折扣价</span>
          </td>
          <td>
              <el-input-number   v-model="configser.soldout" size="mini"   />
          </td>
        </tr>
        <tr >
          <td>
            <span class="simpleLabel">设置状态</span>
          </td>
          <td>
             <el-select v-model="configser.state" placeholder="请选择" size='mini'>
    <el-option
      label="正常"
      :value="0">
    </el-option>
    <el-option
      label="下架"
      :value="1">
    </el-option>
    
  </el-select>
              <!-- <el-input-number   v-model="configser.soldout" size="mini"   /> -->
          </td>
        </tr>
          </table>
        </div>
      </div>
      <div class="footer" slot="foter">
        <el-button @click="showConfig=false" size="mini">取消</el-button>
        <el-button @click="dosavecoor(0)" type="primary" size="mini">保存</el-button>
      </div>
    </modalreal>
    <modalreal :zIndexEdit='false' :width='600' :height='400' v-if="showConfig1">
      <div slot="title">
        设置{{setobj.shopMain.name}}门店的商品{{prodID.name}}库存
      </div>
      <div style="flex:1" slot="contner">
        <div class="grid-content content-margin">
          <table class="simpleRow">
        <tr >
          <td>
            <span class="simpleLabel">新增商品库存</span>
          </td>
          <td>
              <el-input-number :min='0'  v-model="storeobj.increaseQuantity" size="mini"   />
          </td>
        </tr>
         <tr >
          <td>
            <span class="simpleLabel">备注</span>
          </td>
          <td>
              <el-input   v-model="storeobj.comment" size="mini"   />
          </td>
        </tr>
        
          </table>
        </div>
      </div>
      <div class="footer" slot="foter">
        <el-button @click="showConfig1=false" size="mini">取消</el-button>
        <el-button @click="setobg(0)" type="primary" size="mini">保存</el-button>
      </div>
    </modalreal>
     <modalreal :zIndexEdit='false' :width='600' :height='400' v-if="showConfig2">
      <div slot="title">
        设置{{setobj.shopMain.name}}门店的商品{{prodID.name}}库存
      </div>
      <div style="flex:1" slot="contner">
        <div class="grid-content content-margin">
          <table class="simpleRow">
        <tr >
          <td>
            <span class="simpleLabel">设置商品库存</span>
          </td>
          <td>
              <el-input-number :min='0'  v-model="storeobj1.increaseQuantity" size="mini"   />
          </td>
        </tr>
         <tr >
          <td>
            <span class="simpleLabel">备注</span>
          </td>
          <td>
              <el-input   v-model="storeobj1.comment" size="mini"   />
          </td>
        </tr>
        
          </table>
        </div>
      </div>
      <div class="footer" slot="foter">
        <el-button @click="showConfig2=false" size="mini">取消</el-button>
        <el-button @click="editobg(0)" type="primary" size="mini">保存</el-button>
      </div>
    </modalreal>
  </div>
</template>

<script>
import shelvesStore2 from "@/components/productStore/shelvesStore2";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
  import modalreal from '@/components/modalCom/modalreal'


export default {
    name:'shopSelectionProd',
    components: {
    shelvesStore2,
    modalreal
  },
     props: {
    // 是否使用复选
    isModify: {
      type: Boolean,
      default: true,
    },
    prodID:{
      type:Object,
      default:{
        data:0,
        name:''
      }
    }
     },
    data(){
        return {
          showConfig:false,
            productFlag:false,
            tableData:[],
            config:{
                slot:true,
                posturl:'/manage/shopcommodityinventory/getcommodityinventory'
            },
            keyItem:'shopMain.shopid',
            sendData:{
            "appID": 188,
            "filterConfig": {
              "appID": 188,
              "commodityID": -1,
              "filterType": 0,
              "keyword": "",
              "name": "",
              "shopNo": "",
              "type": 0
            },
            "pageConfig": {
              "page": 1,
              "pageStartIndex": 0,
              "pagesize": 20
            },
            "sortConfig": {
              "order": "",
              "prop": ""
            }
          },
            configser:{
              appid:188,
               "commodityid": 0,
                "inventory": 0,
                "inventoryalarm": 0,
                inventorytense:0,
                inventoryoffshelf:0,
                "price": 0,
                "replenishprice": 0,
                "shopid": 0,
                "soldout": 0,
                "state": 0
            },
            isadd:true,
            setobj:null,
            showConfig1:false,
            storeobj:{
              appID:188,
              comment:'',
              commodityID:-1,
              increaseQuantity:0,
              shopID:0
            },
            showConfig2:false,
            storeobj1:{
              appID:188,
              comment:'',
              commodityID:-1,
              increaseQuantity:0,
              shopID:0
            },

        }
    },
    methods:{
      setobg(){
        rejecthttp(false, 'post', "/manage/shopcommodityinventory/increaseshopinventory", this.storeobj, this, (doc) => {
                changeflagCLOSED(doc, 0, this)
                if (doc.data.Code == "MSGKEY_OK") {
                    this.showConfig1=false
                }
            });
      },
      editobg(){
        rejecthttp(false, 'post', "/manage/shopcommodityinventory/setshopinventory", this.storeobj1, this, (doc) => {
                changeflagCLOSED(doc, 0, this)
                if (doc.data.Code == "MSGKEY_OK") {
                    this.showConfig2=false
                }
            });
      },
      dosavecoor(){
        this.showConfig=false

        // console.log('baocun')
        if(this.isadd){
          this.addstore()
        }else{
          this.editstore()
        }
      },
      addstore(){
          rejecthttp(false, 'post', "/manage/shopcommodityinventory/addinventory", this.configser, this, (doc) => {
                changeflagCLOSED(doc, 0, this)
                if (doc.data.Code == "MSGKEY_OK") {
                    
                }
            });
      },
      editstore(){
          rejecthttp(false, 'post', "/manage/shopcommodityinventory/editinventory", this.configser, this, (doc) => {
                changeflagCLOSED(doc, 0, this)
                if (doc.data.Code == "MSGKEY_OK") {
                    
                }
            });
      },
      setStore(e){
        this.storeobj.commodityID=this.prodID.data
        this.storeobj.shopID=e.shopMain.shopid
        this.setobj=e
        this.showConfig1=true

        console.log(e)
      },
      editStore(e){
        this.storeobj1.commodityID=this.prodID.data
        this.storeobj1.shopID=e.shopMain.shopid
        this.setobj=e
        this.showConfig2=true

        console.log(e)
      },
      editProd(e){
        this.setobj=e
        this.configser.shopid=e.shopMain.shopid
        this.configser.commodityid=this.prodID.data
        rejecthttp(false, 'get', `/manage/shopcommodityinventory/inventorydetail?appid=188&shopid=${this.configser.shopid}&commodityid=${this.configser.commodityid}`, {}, this, (doc) => {
                changeflagCLOSED(doc, 0, this)
                if (doc.data.Code == "MSGKEY_OK") {
                  this.configser=doc.data.data
                    this.isadd=false
                    this.showConfig=true
                }
            });
        
      },
      setProd(e){
        console.log(e)
        this.configser.shopid=e.shopMain.shopid
        this.configser.commodityid=this.prodID
        this.setobj=e

        this.isadd=true
        this.showConfig=true
      },
        setValue(i,k,r){
          let v=JSON.parse(JSON.stringify(this.tableData))
          v[i][k]=r
          this.$emit('update:tableData',v)
        },
        selectProduct(){
            
            this.productFlag=true
        },
        deleteTableDate(e,r){
            console.log(e,r)
            let v=JSON.parse(JSON.stringify(this.tableData))
           
            v.splice(e.$index,1)
            let h=[]

             v.forEach(item => {
              h.push({
                shopid:item.shopid,
                name:item.name,
                activityid:this.activityid,
                 limit:item.limit?item.limit:0,
                unit:item.unit?item.unit:0,
                maxparticipatetimes:item.maxparticipatetimes?item.maxparticipatetimes:0
              })
            });
            this.$emit('update:tableData',h)

        },
        saveret(e){
            // this.tableData=this.tableData.concat(e.sel)
            
            let v=JSON.parse(JSON.stringify(this.tableData))
            console.log(e)
            let h=[]

             v.forEach((item,index) => {
              h.push({
                shopid:item.shopid,
                name:item.name,
                activityid:this.activityid,
                limit:item.limit?item.limit:0,
                unit:item.unit?item.unit:0,
                maxparticipatetimes:item.maxparticipatetimes?item.maxparticipatetimes:0
              })
            });
             e.sel.forEach(item => {
              h.push({
                shopid:item.shopid,
                name:item.name,
                activityid:this.activityid,
                limit:0,
                unit:0,
                maxparticipatetimes:0
              })
            });
            console.log(h)
            this.$emit('update:tableData',h)
            // this.$emit('update:tableData',v.concat(e.sel))
        },
        getCurrentData(){
          
        }
    },
    mounted(){
        console.log(this.tableData)
        this.sendData.filterConfig.commodityID=this.prodID.data
        this.sendData.filterConfig.commodityID=JSON.parse(JSON.stringify(this.sendData.filterConfig.commodityID))
        // this.getCurrentData()
    },
    watch:{
      prodID(n,o){
        console.log(n,o)
        this.sendData.filterConfig.commodityID=n.data
        this.sendData.filterConfig.commodityID=JSON.parse(JSON.stringify(this.sendData.filterConfig.commodityID))

      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/elementSelect/shopSelectionProd.vue